import { Guid } from "guid-typescript";
import { UserManager, User } from "oidc-client";

export interface IAuthenticationServiceSettings {
  onAccessTokenExpired?: () => void;
}

class AuthenticationService {
  private readonly userManager: UserManager;
  public readonly id: string;
  public authenticationProcessing: boolean;

  public constructor(userManager: UserManager, authenticationServiceSettings: IAuthenticationServiceSettings) {
    this.userManager = userManager;
    this.id = Guid.raw();
    this.authenticationProcessing = false;

    this.userManager.events.addAccessTokenExpired(() => {
      if (!this.authenticationProcessing) {
        authenticationServiceSettings.onAccessTokenExpired?.();
      }
    });
  }

  /* istanbul ignore next */
  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  /* istanbul ignore next */
  public startSignIn(): Promise<void> {
    this.authenticationProcessing = true;

    return this.userManager.signinRedirect();
  }

  /* istanbul ignore next */
  public completeSignIn(): Promise<User | null> {
    return this.userManager.signinRedirectCallback();
  }

  /* istanbul ignore next */
  public signOut(): Promise<void> {
    return this.userManager.signoutRedirect();
  }

  public isValidUser(user: User | null) {
    return user && !user.expired;
  }
}

export let authenticationService: AuthenticationService;

export const configureAuthenticationService = (userManager: UserManager, authenticationServiceSettings: IAuthenticationServiceSettings) => {
  if (!authenticationService) {
    authenticationService = new AuthenticationService(userManager, authenticationServiceSettings);
  }
};
